import { render } from "./AqcuireUsageDetail.vue?vue&type=template&id=04606af4"
import script from "./AqcuireUsageDetail.vue?vue&type=script&lang=js"
export * from "./AqcuireUsageDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__